// extracted by mini-css-extract-plugin
export var acitonButtons = "_lz-0";
export var additionalIcon = "_lz-f";
export var block = "_lz-1";
export var blockContent = "_lz-7";
export var blockDescription = "_lz-8";
export var blockIcon = "_lz-9";
export var blockTitle = "_lz-6";
export var border = "_lz-a";
export var center = "_lz-l";
export var edge = "_lz-b";
export var edgeLabel = "_lz-c";
export var edgePath = "_lz-d";
export var error = "_lz-e";
export var flowchart = "_lz-g";
export var flowchartContent = "_lz-h";
export var highlighted = "_lz-3";
export var hover = "_lz-4";
export var icon = "_lz-i";
export var left = "_lz-m";
export var navButton = "_lz-j";
export var navButtons = "_lz-k";
export var right = "_lz-n";
export var selected = "_lz-2";
export var small = "_lz-5";